"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInput = void 0;
const react_1 = __importDefault(require("react"));
const _ui_1 = require("@ui");
const i18n_1 = require("@app/util/i18n");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const SearchInput = ({ onChange, onKeyDown, onCancel, value, }) => (react_1.default.createElement("div", { className: 'ds-st-search ' + ((value && value.length >= 2) ? 'has-value' : '') },
    react_1.default.createElement(_ui_1.Icon, { ico: 'search' }),
    react_1.default.createElement(_ui_1.Input, { style: _ui_1.Input.STYLES.BORDERLESS, size: _ui_1.Input.SIZES.FULL_WIDTH, type: 'text', autoFocus: true, placeholder: (0, maybe_unwrap_1.unwrapMaybe)((0, i18n_1.t)('CAL_SEARCH_PLACEHOLDER')), onChange: onChange, value: value, onKeyDown: onKeyDown }),
    react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.close1, onClick: onCancel })));
exports.SearchInput = SearchInput;
exports.default = exports.SearchInput;
